export function processSchema<S extends object>(schema: S) {
  const result = Object.assign({}, schema);

  make(result, '');

  return result;
}

function make<O extends object>(obj: O, parentKey: string) {
  for (const key of Object.keys(obj)) {
    if (typeof obj[key] === 'string') {
      obj[key] = `${parentKey}.${key}`.replace(/^./, '');
    } else {
      const pk = `${parentKey}.${key}`;

      make(obj[key], pk);
    }
  }
}
